export default "<div class=\"account__container\">\n  <router-outlet></router-outlet>\n</div>\n"